import { SalesSplitRow } from 'src/app/shared/components/sales-split-card/sales-split-card.component';
import { SALES_CHANNEL_COLORS } from 'src/app/types/sales-channel-colors';
import { unwrapReportData } from './event-kpis.mapper';

/** Monto vendido por canal, ya en número. */
export interface ChannelAmounts {
  readonly direct: number;
  readonly ecommerce: number;
  readonly free: number;
}

export const EMPTY_CHANNEL_AMOUNTS: ChannelAmounts = { direct: 0, ecommerce: 0, free: 0 };

const toAmount = (value: unknown): number => {
  const amount = Number(value ?? 0);
  return Number.isFinite(amount) ? amount : 0;
};

/** Montos por canal de `sales_report_table` (la API los manda como string). */
export function mapChannelAmounts(raw: unknown): ChannelAmounts {
  const d = unwrapReportData(raw);
  return {
    direct: toAmount(d['total_direct_amount']),
    ecommerce: toAmount(d['total_ecommerce_amount']),
    free: toAmount(d['total_free_amount']),
  };
}

/**
 * Filas de `sales-split-card`: solo canales con monto > 0, con el % redondeado
 * sobre la suma de los canales. Lo usan el bloque del Jefe y Mis ventas.
 */
export function buildChannelSplitRows({ direct, ecommerce, free }: ChannelAmounts): SalesSplitRow[] {
  const total = direct + ecommerce + free;
  const channels = [
    { labelKey: 'dashboard-seller.split.direct', amount: direct, color: SALES_CHANNEL_COLORS.direct },
    { labelKey: 'dashboard-seller.split.ecommerce', amount: ecommerce, color: SALES_CHANNEL_COLORS.ecommerce },
    { labelKey: 'dashboard-seller.split.free', amount: free, color: SALES_CHANNEL_COLORS.free },
  ];
  return channels
    .filter((channel) => channel.amount > 0)
    .map((channel) => ({ ...channel, percent: Math.round((channel.amount / total) * 100) }));
}
